import APIS from 'src/constants/ApiConfig';
import { IAgentInfo } from 'src/entity/AgentEntity';
import { IDrugStoreInfo } from 'src/entity/DrugStoreEntity';
import { ILoginParam, ILoginResult, IResetPassword, IVerificationCode, ResetPwdType, ResetByMobile } from 'src/entity/LoginParam';
import HttpService from 'src/services/HttpService';

/**
 * 登录Service
 * @class LoginService
 */
class LoginService {
  userLogin(data: ILoginParam): Promise<ILoginResult> {
    data.system = '001.101.001';
    return HttpService.post(APIS.businessUrl(APIS.login), data);
    // return new Promise((resolve, reject) => {
    //   HttpService.post(APIS.businessUrl(APIS.login), data)
    //     .then(async (res: ILoginResult) => {
    //       SessionService.AccessToken = res.access_token as string;
    //       WebSocketService.connect(res.access_token as string);
    //       if (!!res.extra_data) {
    //         const isTrue = RouterConfig.checkMenuItems(res.extra_data.functions);
    //         if (!!isTrue) {
    //           let menuItems = RouterConfig.MenuItems.menus;
    //           if (!!res.extra_data.functions && res.extra_data.functions.length > 0) {
    //             menuItems = res.extra_data.functions;
    //           }
    //           const tempMenuItem: RouterConfig.IMenuItems = {
    //             menus: menuItems,
    //             others: RouterConfig.MenuItems.others,
    //           };
    //           SessionService.UserRoleMenuItem = tempMenuItem;
    //           resolve(res);
    //         } else {
    //           console.error('user role config of router error!');
    //           reject(res);
    //         }
    //       } else {
    //         console.error('user role config of router error!');
    //         reject(res);
    //       }
    //     })
    //     .catch(error => {
    //       reject(error);
    //     });
    // });
  }

  async agentLogout(): Promise<any> {
    try {
      await HttpService.post(APIS.domainUrl(APIS.logout), null);
      return true;
    } catch (error) {
      return error;
    }
  }

  sendVerifyCode = (data: IVerificationCode, type: ResetPwdType): Promise<any> => {
    if (type === ResetByMobile) {
      return HttpService.post(APIS.businessUrl(APIS.verifyCodeMobile), data);
    } else {
      return HttpService.post(APIS.businessUrl(APIS.verifyCodeEmail), data);
    }
  };

  resetPassword = (data: IResetPassword, type: ResetPwdType): Promise<any> => {
    if (type === ResetByMobile) {
      return HttpService.post(APIS.businessUrl(APIS.resetPasswordMobile), data);
    } else {
      return HttpService.post(APIS.businessUrl(APIS.resetPasswordEmail), data);
    }
  };

  getCurrentAgent = (): Promise<IAgentInfo | IDrugStoreInfo> => {
    return HttpService.get(APIS.domainUrl(APIS.agentSelf));
  };

  /**
   * 获取当前登录的配药中心信息
   * @deprecated
   * @memberof LoginService
   */
  getCurrentDrugStore = (): Promise<IDrugStoreInfo> => {
    return HttpService.get(APIS.domainUrl(APIS.drugStoreSelf));
  };
}

export default new LoginService();



// WEBPACK FOOTER //
// ./src/services/LoginService.ts